import { JSONContent } from '@tiptap/core';
import { z } from 'zod';

/**
 * ProseMirror JSON is a recursive tree structure. Using z.lazy() for deep
 * recursive validation is extremely expensive (exponential with nesting depth).
 * Since this data comes from the server and is already well-formed, we use a
 * lightweight passthrough schema that only checks the top-level shape.
 */
export const ProseMirrorJSONSchema: z.ZodType<JSONContent> = z
  .object({
    type: z.string().optional(),
    attrs: z.record(z.any()).optional(),
    content: z.array(z.any()).optional(),
    marks: z.array(z.any()).optional(),
    text: z.string().optional()
  })
  .passthrough() as z.ZodType<JSONContent>;
